import axios from 'axios';
import {
  Department,
  Position,
  CreateDepartmentRequest,
  UpdateDepartmentRequest,
  CreatePositionRequest,
  UpdatePositionRequest
} from '../types/organization';

const API_URL = '/api';

// トークンを取得
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ==================== 部署API ====================

export const getDepartments = async (): Promise<Department[]> => {
  const response = await axios.get(`${API_URL}/departments`, {
    headers: getAuthHeader()
  });
  return response.data.departments;
};

export const createDepartment = async (data: CreateDepartmentRequest): Promise<Department> => {
  const response = await axios.post(`${API_URL}/departments`, data, {
    headers: getAuthHeader()
  });
  return response.data.department;
};

export const updateDepartment = async (
  id: number,
  data: UpdateDepartmentRequest
): Promise<Department> => {
  const response = await axios.put(`${API_URL}/departments/${id}`, data, {
    headers: getAuthHeader()
  });
  return response.data.department;
};

export const deleteDepartment = async (id: number): Promise<void> => {
  await axios.delete(`${API_URL}/departments/${id}`, {
    headers: getAuthHeader()
  });
};

// ==================== 役職API ====================

export const getPositions = async (): Promise<Position[]> => {
  const response = await axios.get(`${API_URL}/positions`, {
    headers: getAuthHeader()
  });
  return response.data.positions;
};

export const createPosition = async (data: CreatePositionRequest): Promise<Position> => {
  const response = await axios.post(`${API_URL}/positions`, data, {
    headers: getAuthHeader()
  });
  return response.data.position;
};

export const updatePosition = async (
  id: number,
  data: UpdatePositionRequest
): Promise<Position> => {
  const response = await axios.put(`${API_URL}/positions/${id}`, data, {
    headers: getAuthHeader()
  });
  return response.data.position;
};

export const deletePosition = async (id: number): Promise<void> => {
  await axios.delete(`${API_URL}/positions/${id}`, {
    headers: getAuthHeader()
  });
};

export const getPositionViewableUsers = async (positionId: number): Promise<number[]> => {
  const response = await axios.get(`${API_URL}/positions/${positionId}/viewable-users`, {
    headers: getAuthHeader()
  });
  return response.data.viewableUserIds;
};
